import {
  CustomizableDetailTabs,
  type BackofficePageMode,
  type CustomizableDetailTabsProps,
} from '@/components/shared';
import { MessageBusPageActionsMenu } from './MessageBusPageActionsMenu';

export interface MessageBusPageHeaderProps<TTabId extends string> {
  showTabs: boolean;
  tabs: CustomizableDetailTabsProps<TTabId>['tabs'];
  pageLabel: string;
  pageMode: BackofficePageMode;
  onPageModeChange: (pageMode: BackofficePageMode) => void;
  onRefresh: () => void;
  refreshing?: boolean | undefined;
}

export function MessageBusPageHeader<TTabId extends string>({
  showTabs,
  tabs,
  pageLabel,
  pageMode,
  onPageModeChange,
  onRefresh,
  refreshing = false,
}: MessageBusPageHeaderProps<TTabId>) {
  if (!showTabs) {
    return (
      <div className="flex justify-end">
        <MessageBusPageActionsMenu
          pageLabel={pageLabel}
          pageMode={pageMode}
          onPageModeChange={onPageModeChange}
          onRefresh={onRefresh}
          refreshing={refreshing}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
      <div className="min-w-0 flex-1">
        <CustomizableDetailTabs tabs={tabs} />
      </div>
      <div className="shrink-0 self-end md:self-start">
        <MessageBusPageActionsMenu
          pageLabel={pageLabel}
          pageMode={pageMode}
          onPageModeChange={onPageModeChange}
          onRefresh={onRefresh}
          refreshing={refreshing}
        />
      </div>
    </div>
  );
}
